import { FIELD_TYPES } from "constants/template-field-type";
import GridParagraphWithImageFieldsConfig from "segments/desktop/core-components/grid-paragraph-with-image/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Sliding Card",
  fields: {
    ...ThemeConfig,
    cardsToShow: { type: FIELD_TYPES.TEXT, label: "Number of cards to show in view" },
    cardColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Card color" },
    cardInnerPadding: { type: FIELD_TYPES.TEXT, label: "Card paragraph padding" },
    isFullScreen: { type: FIELD_TYPES.BOOLEAN, label: "Is full screen" },
    borderColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Border color" },
    arrowsColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Arrows color" },
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Cards",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        label: "Sliding Card",
        fields: GridParagraphWithImageFieldsConfig
      }
    }
  }
};
